import { PublicAction, PublicActionTypes } from './actions';
import { CustomerRecordFactory, DealershipSettingsRecordFactory, PublicStateFactory } from './factories';

const initialState = PublicStateFactory();

function publicReducer(state = initialState, action: PublicAction) {
  switch (action.type) {
    case PublicActionTypes.GET_CUSTOMER_SUCCESS: {
      return state.set('customer', CustomerRecordFactory(action.payload.customer));
    }
    case PublicActionTypes.GET_DEALERSHIP_SETTINGS_SUCCESS: {
      return state.set('dealershipSettings', DealershipSettingsRecordFactory(action.payload.dealershipSettings));
    }
    case PublicActionTypes.UPDATE_CUSTOMER_SUCCESS:
    case PublicActionTypes.CREATE_CUSTOMER_DOCUMENT_SUCCESS:
    case PublicActionTypes.GET_CUSTOMER_FAIL:
    case PublicActionTypes.GET_DEALERSHIP_SETTINGS_FAIL:
    case PublicActionTypes.UPDATE_CUSTOMER_FAIL:
    case PublicActionTypes.CREATE_CUSTOMER_DOCUMENT_FAIL: // TODO: implement error handling
    default:
      return state;
  }
}

export default publicReducer;
